export const API_BASE_URL = import.meta.env.VITE_NEW_WORDS_API_URL || 'http://localhost:8080'
